module.exports = __webpack_public_path__ + "static/media/memories_5.05265c62.jpg";